module.exports = __webpack_public_path__ + "static/media/menu.09811516.svg";